var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(_vm.$auth.ready())?_c(_vm.layout,{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.params.loginToken),expression:"!$route.params.loginToken"}],tag:"component"},[_c('router-view')],1):_vm._e(),_vm._v(" "),_c('the-alerts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }